import CanShow from "./CanShow";
import Projects from "@/features/donations/projects/pages/page";
import ProjectForm from "@/features/donations/projects/pages/form/page";
import Donations from "@/features/donations/donations/Index";
import RecurringPayment from "@/features/donations/recurringPayment/Index";
import Carts from "@/features/donations/carts/Index";

export const donationsRoutes = [
  {
    path: "/projects",
    element: (
      <CanShow page={<Projects />} ifHas={["viewProjects", "editProjects"]} />
    ),
  },
  {
    path: "/projects/create",
    element: <ProjectForm />,
  },
  {
    path: "/projects/:edit/edit",
    element: <CanShow page={<ProjectForm />} ifHas={["editProjects"]} />,
  },
  {
    path: "/projects/:show",
    element: <CanShow page={<ProjectForm />} ifHas={["viewProjects"]} />,
  },
  {
    path: "/donations",
    element: <CanShow page={<Donations />} ifHas={["viewDonations"]} />,
  },
  {
    path: "/recurring-payment",
    element: <CanShow page={<RecurringPayment />} ifHas={["viewDonations"]} />,
  },
  {
    path: "/carts",
    element: <CanShow page={<Carts />} ifHas={["abandonedCarts"]} />,
  },
];
